export function inView (elm, func, inFrame) {
  const e = document.querySelector(elm)
  const b = e.getBoundingClientRect()
  const eHeight = window.getComputedStyle(e).height
  const wHeight = window.innerHeight || document.documentElement.clientHeight
  let isInView = false
  switch (inFrame) {
    case 'top':
      isInView =
        b.top >= 0 &&
        b.left >= 0 &&
        b.right <= (window.innerWidth || document.documentElement.clientWidth)
      break
    case 'topvisible':
        isInView =
          b.top <= wHeight;
        break
    case 'inBetween':
      isInView =
        b.top <= 430
      break
    case 'mid':
      isInView =
        (b.top <= wHeight / 2 || b.top <= eHeight) &&
        b.left >= 0 
      break
    case 'bottom':
      isInView =
      Math.floor(b.bottom) <= (window.innerHeight || document.documentElement.clientHeight)
      break
    case 'all':
    default:
      isInView =
        b.top >= 0 &&
        b.left >= 0 &&
        Math.floor(b.right) <= (window.innerWidth || document.documentElement.clientWidth) &&
        Math.floor(b.bottom) <= (window.innerHeight || document.documentElement.clientHeight)
      break
  }
  if (isInView) {
    func()
    return true
  } else {
    return false
  }
}